/* eslint-disable import/prefer-default-export */

export const GET_BOOKINGS = "GET_BOOKINGS";
export const GET_BOOKINGS_ERROR = "GET_BOOKINGS_ERROR";
